import { render, staticRenderFns } from "./zpDetail.vue?vue&type=template&id=5f1981a0&scoped=true"
import script from "./zpDetail.vue?vue&type=script&lang=js"
export * from "./zpDetail.vue?vue&type=script&lang=js"
import style1 from "./zpDetail.vue?vue&type=style&index=1&id=5f1981a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1981a0",
  null
  
)

export default component.exports